module.exports = __webpack_public_path__ + "static/img01-0c996a95eaaf1705fc0af1ba6689a303.png";